"use client";
import Image from "next/image";
import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const CloudsAnimation = () => {
  const bodyContainer = useRef(null);
  const cloud1 = useRef(null);
  const cloud2 = useRef(null);
  const cloud3 = useRef(null);
  const cloud4 = useRef(null);
  useEffect(() => {
    const container = bodyContainer.current;
    const cloudImage1 = cloud1.current;
    const cloudImage2 = cloud2.current;
    const cloudImage3 = cloud3.current;
    const cloudImage4 = cloud4.current;
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "15% bottom",
        end: "bottom 80%",
        scrub: 3,
      },
    });

    // Define individual animations for each cloud
    tl.to(cloudImage1, { x: -400, duration: 2 }, 0)
      .to(cloudImage2, { x: -250, duration: 2 }, 0)
      .to(cloudImage3, { x: 350, duration: 2 }, 0)
      .to(cloudImage4, { x: 200, duration: 2 }, 0);
  });
  return (
    <div className="relative h-[600px]" ref={bodyContainer}>
      <Image
        ref={cloud1}
        className="absolute top-[0%] sm:top-0 right-[-15%] max-w-[350px] md:max-w-[572px] w-full"
        src={"/assets/images/png/blueClouds.png"}
        alt="blue Cloud"
        width={572}
        height={284}
      />
      <Image
        ref={cloud2}
        className="absolute right-[-70%]  top-[-15%] sm:top-[10%] lg:right-[-25%] xl:right-[-20%] max-w-[350px] md:max-w-[572px] w-full"
        src={"/assets/images/png/pinkCloud2.png"}
        alt="blue Cloud"
        width={572}
        height={284}
      />
      <Image
        ref={cloud3}
        className="absolute top-[0%] sm:top-0 left-[-100%] lg:left-[-34%] xl:left-[-30%] max-w-[350px] md:max-w-[572px] w-full"
        src={"/assets/images/png/pinkCloud1.png"}
        alt="blue Cloud"
        width={572}
        height={284}
      />
      <Image
        ref={cloud4}
        className="absolute md:block hidden top-[20%] left-[-15%] max-w-[350px] md:max-w-[572px] w-full"
        src={"/assets/images/png/blueClouds.png"}
        alt="blue Cloud"
        width={572}
        height={284}
      />
    </div>
  );
};

export default CloudsAnimation;
